/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import createLoadableComponent from 'js/lib/createLoadableComponent';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import { DEFAULT_PAGE_HEADER_HEIGHT } from 'bundles/composable-page-header/constants';
import { usePageHeaderHeight } from 'bundles/composable-page-header/contexts/PageHeaderHeightContext';
import { usePageHeaderOffset } from 'bundles/composable-page-header/contexts/PageHeaderOffsetContext';
import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import { shouldShowNewMegamenu } from 'bundles/megamenu/utils/experimentUtils';
import MegaMenuWrapper from 'bundles/page-header/components/desktop/mega-menu/MegaMenuWrapperLite';
import LazyLoadingHandler from 'bundles/page/components/shared/LazyLoadingHandler';

const LoadableMegaMenu = createLoadableComponent(
  () => import('bundles/page-header/components/optimized/MegaMenuContent'),
  LazyLoadingHandler
);

type Props = {
  // Render menu content on server for SEO reasons, used on logged-out homepage.
  renderMenuOnServer?: boolean;
};

const LegacyExploreMegaMenuGridItem = ({ renderMenuOnServer }: Props) => {
  const headerHeight = usePageHeaderHeight()?.height ?? DEFAULT_PAGE_HEADER_HEIGHT;
  const headerOffset = usePageHeaderOffset()?.scrollMovementOffset ?? 0;
  const { hasEnrolledPrograms, isCourseraPlusLearner } = useConsumerMyPageHeader();

  const setTopStyle = () => css`
    .rc-MegaMenuWrapper {
      .mega-menu-overlay--lazy-loading {
        top: ${headerHeight}px !important;
        height: calc(100vh - ${headerHeight - headerOffset}px) !important;
      }
    }
  `;

  return (
    <div className="rc-LegacyExploreMegaMenuGridItem" css={setTopStyle()}>
      {shouldShowNewMegamenu() ? (
        <SimplifiedMegaMenuWrapper shouldShowCourseraPlusButton={!isCourseraPlusLearner && !hasEnrolledPrograms} />
      ) : (
        <MegaMenuWrapper
          renderMenuOnServer={renderMenuOnServer}
          key="MegamenuWrapper"
          LoadableMegaMenu={LoadableMegaMenu}
        />
      )}
    </div>
  );
};

export default LegacyExploreMegaMenuGridItem;
